import Container from "../element/container";
import { MDBModalBody } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import FullModal from "./full.modal";
import Icon from "../element/icon";
import AccountModalHeader from "../common/account.modal.header";
import { getOrderReceipts } from "../../helpers/order.receipts";
import { downloadIfPrivate, openIfPrivate } from "../../helpers/secure.file";

const money = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const amount = Number(String(value).replace(/[^0-9.-]/g, ""));
  if (!Number.isFinite(amount)) return String(value);
  return `RM ${amount.toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const when = (value) => {
  if (!value) return "";
  const date = dayjs(value);
  return date.isValid() ? date.format("D MMM YYYY") : String(value);
};

export default function OrderReceiptsModal({ order, onClose }) {
  const { t } = useTranslation();
  // The record only offers this screen when the order actually has receipts.
  const payments = getOrderReceipts(order);
  const name = order?.name || order?.product?.name || "Vehicle";
  const reference = order?.reservationId || order?.reference_no || "-";

  return (
    <FullModal independent show close={onClose} showCloseButton centered scrollable screenSize="lg"
      className="product-action-modal saved-car-modal order-receipts-modal"
      dialogClassName="action-modal-dialog saved-car-modal-dialog"
      contentClassName="action-modal-content saved-car-modal-content"
      content={
        <MDBModalBody className="saved-car-modal-body order-receipts-dialog">
          <AccountModalHeader
            title={t("Official Receipt")}
            subtitle={`${name} | ${reference}`}
            icon="solar:bill-list-linear"
          />

          {payments.length ? (
            <ol className="order-receipt-list">
              {payments.map((payment) => (
                <li className="order-receipt-card" key={payment.id}>
                  <Container tag="div" className="order-receipt-head">
                    <span className="order-receipt-label">{t(payment.label)}</span>
                    {payment.amount !== null && (
                      <strong className="order-receipt-amount">{money(payment.amount)}</strong>
                    )}
                  </Container>

                  {payment.date && (
                    <p className="order-receipt-date">
                      <Icon tag="span" icon="solar:calendar-linear" />
                      {when(payment.date)}
                    </p>
                  )}

                  <Container tag="div" className="order-receipt-files">
                    {payment.files.map((file) => (
                      <Container tag="div" className="order-receipt-file" key={file.url}>
                        <span className="order-receipt-file-name">{file.name}</span>
                        <span className="order-receipt-file-actions">
                          <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            role="button"
                            onClick={(event) => openIfPrivate(event, file.url)}
                          >
                            <Icon tag="span" icon="solar:eye-linear" />
                            {t("View")}
                          </a>
                          <a
                            href={file.url}
                            download={file.name}
                            className="is-primary"
                            role="button"
                            onClick={(event) => downloadIfPrivate(event, file.url, file.name)}
                          >
                            <Icon tag="span" icon="solar:download-minimalistic-linear" />
                            {t("Download")}
                          </a>
                        </span>
                      </Container>
                    ))}
                  </Container>
                </li>
              ))}
            </ol>
          ) : (
            <p className="order-documents-empty" role="status">
              {t("No official receipt is available for this order yet.")}
            </p>
          )}
        </MDBModalBody>
      }
    />
  );
}
